import { Tierliste } from '../../../gruppe-tier/classes/tierliste';
import { Gruppe } from '../../classes/gruppe';

export class TierlistenauswahlDialogInput {
    gruppe: Gruppe;
    /** When no Abgangsgruppe is set (e.g. Kundenportal start page), filter by selected Betrieb. */
    kunde_id?: number;
    onlyActive: boolean;
    tierlisten: Tierliste[] = [];
}
